import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { SettingsQueryKey } from './queryKey';
export var useGetHrmSettings = function (companyId, enabled) {
    if (enabled === void 0) { enabled = true; }
    var intl = useIntl();
    return useQuery([SettingsQueryKey.HrmSettings, companyId], function () {
        return api.base
            .get('/api/settings/hrm', { params: { id: companyId } })
            .then(function (res) { return res.data; });
    }, {
        enabled: !!companyId && enabled,
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
